import React from "react";
import { Box } from "@mui/material";
import Navbar from "@/components/home/Navbar";
import MonitoringIndicatorManager from "@/components/indicators/MonitoringIndicatorManager";

const MonitoringIndicatorPage: React.FC = () => {
  return (
    <Box>
      <Navbar />
      <Box sx={{ p: 3 }}>
        <MonitoringIndicatorManager />
      </Box>
    </Box>
  );
};

export default MonitoringIndicatorPage;